var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g4, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefur6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_4099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_4099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 0,
    width: 43,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0H74.5156V74.0156H32.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_4099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8128 0H46.141C44.0993 0 42.443 1.65625 42.443 3.70313V53.0417H36.2712C34.2295 53.0469 32.5732 54.6979 32.5732 56.7448V67.8438C32.5785 71.25 35.3337 74.0104 38.7399 74.0156H51.0732V71.5469H43.641C44.4587 70.4844 44.9014 69.1823 44.9066 67.8438V3.70313C44.9066 3.02083 45.4587 2.46875 46.141 2.46875H70.8128C71.4951 2.46875 72.0472 3.02083 72.0472 3.70313V67.8438C72.042 69.8906 70.391 71.5417 68.3441 71.5469H65.8805V74.0156H68.3441C71.7503 74.0104 74.5107 71.25 74.516 67.8438V3.70313C74.5107 1.65625 72.8545 0 70.8128 0ZM42.443 67.8438C42.443 69.8906 40.7868 71.5469 38.7399 71.5469C36.6982 71.5469 35.042 69.8906 35.042 67.8438V56.7448C35.042 56.0625 35.5941 55.5104 36.2712 55.5104H42.443V67.8438Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_94_4099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H40.5V74.0156H0.5V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_94_4099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96875 62.1146C2.96875 60.7708 3.69792 59.5313 4.86979 58.8802L12.6979 54.5312L18.4479 59.3281C18.6198 59.4635 18.8073 59.5781 19.0052 59.6667V61.6771C19.0052 62.4583 19.3802 63.1979 20.0104 63.6562L17.8073 72.4792L17.7708 74.0156H20.2396V72.9323L22.4323 64.1458H25.4427L27.6406 72.9323V74.0156H30.1042V72.7812L27.8594 63.6615C28.4948 63.1979 28.8698 62.4635 28.8698 61.6771V59.6667C29.0677 59.5781 29.2552 59.4635 29.4271 59.3281L30.8958 58.1042L29.3177 56.2083L27.8438 57.4323L25.7448 54.6302L30.1406 51.9948C30.8802 51.5469 31.3385 50.7448 31.3385 49.875V46.1042C35.9115 43.4635 38.7344 38.5885 38.7396 33.3073V22.2031H39.974V19.7344H6.66667V17.2708H39.974V11.1042C39.9688 4.97396 35 0.00520833 28.8698 0H19.0052C12.875 0.00520833 7.90625 4.97396 7.90104 11.1042V14.8021H6.66667C5.30729 14.8021 4.20313 15.9063 4.20313 17.2708V19.7396C4.20313 21.099 5.30729 22.2031 6.66667 22.2031H9.13542V33.3073C9.14063 38.5885 11.9635 43.4635 16.5365 46.1042V48.8385C15.6667 48.9063 14.8542 49.2865 14.2344 49.901L12.0885 52.0469L3.67187 56.724C1.71354 57.8125 0.5 59.875 0.5 62.1146V74.0156H2.96875V62.1146ZM33.8073 4.02604C36.1198 5.63542 37.5052 8.28125 37.5052 11.1042V14.8021H33.8073V4.02604ZM16.5365 2.82813C17.3385 2.58854 18.1667 2.46875 19.0052 2.46875H22.7031V12.3333H25.1719V2.46875H28.8698C29.7083 2.46875 30.5365 2.58854 31.3385 2.83333V14.8021H16.5365V2.82813ZM10.3698 11.1042C10.3698 8.28125 11.75 5.63542 14.0677 4.02604V14.8021H10.3698V11.1042ZM25.8698 58.9115C26.0208 59.1042 26.2031 59.276 26.4062 59.4167V61.6771H21.4688V59.4167C21.6719 59.276 21.8542 59.1042 22 58.9115L23.9375 56.3333L25.8698 58.9115ZM28.8698 49.875L23.974 52.8177L19.0052 49.5052V47.2448C22.1927 48.3958 25.6823 48.3958 28.8698 47.2448V49.875ZM11.6042 33.3073V22.2031H36.2708V33.3073C36.2708 40.1198 30.75 45.6406 23.9375 45.6406C17.125 45.6406 11.6042 40.1198 11.6042 33.3073ZM15.9792 51.6458C16.3958 51.2292 17.0469 51.1667 17.5365 51.4896L22.1667 54.5781L20.0313 57.4323L14.6615 52.9583L15.9792 51.6458Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_94_4099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 65,
    width: 5,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16699 65.334H11.167V74.0163H7.16699V65.334Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_94_4099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.90137 65.3809H10.3701V74.0163H7.90137V65.3809Z",
    fill: "#151515"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7705 29.6035C18.4528 29.6035 19.0049 30.1556 19.0049 30.8379C19.0049 31.5202 18.4528 32.0723 17.7705 32.0723C17.0882 32.0723 16.5361 31.5202 16.5361 30.8379C16.5361 30.1556 17.0882 29.6035 17.7705 29.6035Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3018 24.6719H20.2341V27.1406H15.3018V24.6719Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1045 29.6035C30.7868 29.6035 31.3389 30.1556 31.3389 30.8379C31.3389 31.5202 30.7868 32.0723 30.1045 32.0723C29.4222 32.0723 28.8701 31.5202 28.8701 30.8379C28.8701 30.1556 29.4222 29.6035 30.1045 29.6035Z",
    fill: "#151515"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6357 24.6719H32.5732V27.1406H27.6357V24.6719Z",
    fill: "#151515"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 32.0723H25.1719V37.0046H22.7031V32.0723Z",
    fill: "#151515"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0257 40.5306L27.7497 38.416C25.3955 39.8014 22.4788 39.8014 20.1247 38.416L18.8486 40.5306C21.9788 42.4108 25.8955 42.4108 29.0257 40.5306Z",
    fill: "#151515"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_94_4099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 41,
    width: 15,
    height: 34
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.167 41.334H65.8337V74.0163H51.167V41.334Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_94_4099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2456 74.0171H59.7091C61.756 74.0119 63.4122 72.3557 63.4122 70.314V55.663L64.4956 51.3192C64.6414 50.7463 64.5737 50.1421 64.3133 49.6161L61.3654 43.7255C60.5685 42.1317 58.631 41.4859 57.032 42.2828C56.407 42.5953 55.9018 43.1005 55.5893 43.7255L52.6466 49.6161C52.381 50.1421 52.3133 50.7463 52.4591 51.3192L53.5425 55.663V70.314C53.5477 72.3557 55.1987 74.0119 57.2456 74.0171ZM60.9435 70.314C60.9435 70.9963 60.3914 71.5484 59.7091 71.5484H57.2456C56.5633 71.5484 56.0112 70.9963 56.0112 70.314V61.6786H60.9435V70.314ZM60.9435 59.2098H56.0112V56.7463H60.9435V59.2098ZM57.7977 44.8296C58.0164 44.4546 58.5008 44.3296 58.8758 44.5484C58.9956 44.6161 59.0893 44.7151 59.1622 44.8296L62.105 50.7203L61.2143 54.2776H59.7091V50.5796H57.2456V54.2776H55.7404L54.8497 50.7203L57.7977 44.8296Z",
    fill: "#151515"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0781 39.4733H53.5417C54.9063 39.4733 56.0104 38.3691 56.0104 37.0046V34.541C56.0104 33.1764 54.9063 32.0723 53.5417 32.0723H51.0781C49.7135 32.0723 48.6094 33.1764 48.6094 34.541V37.0046C48.6094 38.3691 49.7135 39.4733 51.0781 39.4733ZM51.0781 34.541H53.5417L53.5469 37.0046H51.0781V34.541Z",
    fill: "#151515"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4795 37.0059H60.943V39.4746H58.4795V37.0059Z",
    fill: "#151515"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4111 37.0059H68.3434V39.4746H63.4111V37.0059Z",
    fill: "#151515"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4795 32.0723H60.943V34.541H58.4795V32.0723Z",
    fill: "#151515"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4111 32.0723H68.3434V34.541H63.4111V32.0723Z",
    fill: "#151515"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3441 15.5671C69.4483 14.7702 69.6983 13.2285 68.9014 12.1243C68.7347 11.9004 68.542 11.7025 68.3128 11.5462L59.891 5.65039C59.042 5.05664 57.9118 5.05664 57.0628 5.65039L48.641 11.5462C47.5264 12.3275 47.2503 13.8639 48.0316 14.9837C48.193 15.2077 48.3858 15.4056 48.6097 15.5671V24.6712C48.6097 26.7129 50.266 28.3691 52.3076 28.3691H64.6462C66.6878 28.3691 68.3441 26.7129 68.3441 24.6712V15.5671ZM59.7087 25.9056H57.2451V20.9681H59.7087V25.9056ZM65.8806 24.6712C65.8753 25.3535 65.3285 25.9056 64.6462 25.9056H62.1774V20.9681C62.1774 19.6087 61.0733 18.5046 59.7087 18.5046H57.2451C55.8805 18.5046 54.7764 19.6087 54.7764 20.9681V25.9056H52.3076C51.6305 25.9056 51.0785 25.3535 51.0785 24.6712V16.0358H65.8806V24.6712ZM50.0576 13.5671L58.4795 7.67122L66.9014 13.5671H50.0576Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_4099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefur6);
export default __webpack_public_path__ + "static/media/refur6.c84c6bd99f14c0e2577527bbb5739115.svg";
export { ForwardRef as ReactComponent };